<template>
  <UIButtonCount
    :leading
    :label
    :count
    :variant
    allow-clear
    v-bind="$attrs"
    fill="light"
    data-refid="filter-button"
    tooltip-text="Clear all filters"
    confirm-message="Are you sure you want to clear all filters?"
    class="ui-filter__toggle-button"
    @click:clear="handleClear"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useLocale } from '@/plugins/i18n'

import { UIButtonCount } from '@ui/buttons'
import { FunnelIcon as leading } from '@heroicons/vue/24/outline'

type Props = {
  count?: number
  unlabeled?: boolean
}

type Emits = {
  'click:clear': []
}

const { count, unlabeled } = defineProps<Props>()

const emit = defineEmits<Emits>()

const { t } = useLocale('components.UI.Filter')

const label = computed(() => (count || unlabeled ? undefined : t('Filter')))
const variant = computed(() => (count ? 'secondary' : 'gray'))

const handleClear = () => {
  emit('click:clear')
}
</script>

<style>
.toggle-button {
  @apply h-full;
}
.filter__panel {
  @apply flex justify-between;
  @apply mb-2;

  h3 {
    @apply text-base sm:text-sm;
    @apply text-gray-500;
  }

  button {
    @apply px-2!;
  }
}
.filter__list {
  @apply space-y-2 mb-3;
}
.filter__add {
  @apply flex items-center justify-between;
}
</style>
